import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { ModalCreateEquipamentoMedicao } from "./components/modal_create";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { LegendItemComponent } from "../../../../../common/components/legend_item_component";
import { LegendIcon } from "../../../../../common/components/legend_icon";
import { Header } from "./components/header";
import { GenerateControleColumnDefinition } from "./columns";
import { useMemo } from "react";
import { useObrasEquipamentoMedicaoViewModel } from "../../viewModels/obras_equipamento_medicao_view_modal";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { EquipamentoMedicaoList } from "../../../../equipamentoMedicoes/domain/models/EquipamentoMedicao_List";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { EquipamentoMedicaoHistoricoModal } from "../../../../../common/presentation/components/equipamento_medicao_historico_modal";
import { CopyEquipamentoMedicaoModal } from "./components/copy_equipamento_medicao_modal";

import DeleteDialog from "../../../../../common/components/delete_dialog";

export const ObrasEquipamentoMedicao = () => {
  const viewModel = useObrasEquipamentoMedicaoViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateControleColumnDefinition({
      onActionEditar: viewModel.handleEquipamentoMedicaoCadastroOpenState,
      onActionDeletar: viewModel.handleDeleteEquipamentoMedicaoOpenState,
      onActionCopy: viewModel.handleCopyEquipamentoMedicaoOpenState,
    });
  }, [
    viewModel.handleEquipamentoMedicaoCadastroOpenState,
    viewModel.handleDeleteEquipamentoMedicaoOpenState,
    viewModel.handleCopyEquipamentoMedicaoOpenState,
  ]);

  return (
    <>
      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObra ?? null}
        onBack={viewModel.handleBack}
      />

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link href="/Obras_lista" underline="hover" color="inherit">
            Lista de Obras
          </Link>
          <Typography className="text-primary-green">Lista de Equipamentos</Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title="Lista de Equipamento de Medição"
            selectedObra={viewModel.selectedObra ?? null}
            onReload={viewModel.handleReload}
            onNewItem={viewModel.novoEquipamento}
          />

        </div>

        <Header
          status={viewModel.filters.status}
          equipamento={viewModel.filters.equipamento}
          responsavelPeloEquipamento={viewModel.filters.responsavelPeloEquipamento}
          dataCalibracaode={viewModel.filters.dataCalibracaoDe}
          dataCalibracaoate={viewModel.filters.dataCalibracaoAte}
          onhandleDataCalibracaoChange={viewModel.handleDataCalibracaoRangeChange}
          onEquipamentoChange={viewModel.handleEquipamentoChange}
          onResponsavelPeloEquipamentoChange={viewModel.handleResponsavelPeloEquipamentoChange}
          onStatusChange={viewModel.handleStatusChange}
          onCentroCustoChange={viewModel.handleIdsCentroCustoChange}
          idsCentroCusto={viewModel.filters.idsCentroCusto ?? []}
          centrocustoDropDown={viewModel.ddlCentroCusto ?? []}
          onClear={viewModel.handleClearFilters}
        />

        <Stack spacing={0}>
          <div className="w-full flex flex-row justify-between items-stretch">
            <div className="flex flex-col flex-wrap justify-end">
              <LegendComponent>
                <LegendItemComponent icon={<LegendIcon color="red" title="A" />} label="Atrasado" />

                <LegendItemComponent icon={<LegendIcon color="yellow" title="E" />} label="Em Dia" />
              </LegendComponent>
            </div>

            <div className="flex flex-col justify-between flex-1">
              <TablePagination
                component="div"
                count={viewModel.pagination.totalItems}
                page={viewModel.pagination.page - 1}
                onPageChange={(_, p) => viewModel.handlePageChange(p)}
                rowsPerPageOptions={[10, 25, 50, 100]}
                rowsPerPage={viewModel.pagination.rowsPerPage}
                onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
              />
            </div>
          </div>

          <StyledDataGrid
            tableName="Obras Equipamento Medicao"
            disableColumnMenu={false}
            showToolbar={true}
            disableRowSelectionOnClick={true}
            getRowHeight={() => 'auto'}
            textSize="pequeno"
            getRowId={(row: EquipamentoMedicaoList) => row.idEquipMedicao}
            columns={columnsDefinition}
            loading={viewModel.loading}
            checkboxSelection={false}
            rows={viewModel.equipamentoMedicaoLista}
            rowCount={viewModel.equipamentoMedicaoLista.length}
            pageSizeOptions={[10, 25, 50, 100]}
            paginationMode="server"
            paginationModel={{
              page: viewModel.pagination.page,
              pageSize: viewModel.pagination.rowsPerPage,
            }}
            pinnedColumns={{
              left: ["_check_"],
              right: ["idEquipMedicao"],
            }}
          />

          <div className="flex flex-col justify-between flex-1">
            <TablePagination
              component="div"
              count={viewModel.pagination.totalItems}
              page={viewModel.pagination.page - 1}
              onPageChange={(_, p) => viewModel.handlePageChange(p)}
              rowsPerPageOptions={[10, 25, 50, 100]}
              rowsPerPage={viewModel.pagination.rowsPerPage}
              onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
            />
          </div>
        </Stack>
      </div>

      <ModalCreateEquipamentoMedicao
        open={viewModel.openCreateModal}
        saving={viewModel.saving}
        editmod={true}
        idCentroCusto={viewModel.selectedObra?.idCentroCusto ?? null}
        selectedEquipamentoMedicao={viewModel.selectedEquipamentoMedicao}
        onClose={() => viewModel.handleEquipamentoMedicaoCadastroOpenState(null, false)}
        onSubmit={viewModel.handleEquipamentoMedicaoSubmit}
        onDownloadArquivo={viewModel.handleDownloadArquivo}
        onOpenHistory={id => viewModel.handleHistoricoEquipamentoMedicaoOpenState(id, true)}
      />

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      <EquipamentoMedicaoHistoricoModal
        open={viewModel.openHistoricoModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        itens={viewModel.equipamentoMedicaoHistoricoLista}
        onClose={() => viewModel.handleHistoricoEquipamentoMedicaoOpenState(0, false)}
      />

      <CopyEquipamentoMedicaoModal
        open={viewModel.openCopyModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        funcionariosDropdown={viewModel.ddlFuncionarios}
        onClose={() => viewModel.handleCopyEquipamentoMedicaoOpenState(null, false)}
        onSubmit={viewModel.handleCopyEquipamentoMedicaoSubmit}
      />

      <DeleteDialog
        open={viewModel.openDeleteModal}
        onClose={() => viewModel.handleDeleteEquipamentoMedicaoOpenState(null, false)}
        title={`Você realmente deseja excluir este item?`}
        onDelete={viewModel.handleDeleteEquipamentoMedicaoSubmit}
      />

    </>
  );
};
